import React, { useContext, useEffect, useRef, useState } from 'react';
import { IProps } from './types';
import { IElementUpdate, IActionInfo, IBrandColor } from '../../../../../../../state/brands/types';
import * as S from './styles';
import ColorGenerator from 'components/ColorGenerator';
import ClickOutside from '@components/ClickOutside';
import { BrandsContext } from '@utils/DOIgnition/BrandsContext';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
const uuid = require('react-uuid');

const AddColor: React.FC<IProps> = (props) => {
  const initialColor = "#ffffff";
  const { addUpdateBrand, brandAction, setBrandAction, brandDetail } = useContext(BrandsContext);
  const authContext = useContext(AuthContext);
  const [color, setColor] = useState<string>(initialColor);
  const [saving, setSaving] = useState<boolean>(false);

  const handleColorGeneratorChange = (e:any) => setColor(e);

  const addColor = () => {
    setSaving(true);
    let element: IBrandColor = {
      id: uuid(),
      status: "ACTIVE",
      color: color,
      templatesCount: 0,
      designsCount: 0, 
      actions: [{
        user: {
          email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
          name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
        },
        date: new Date(),
        action: "INSERT"
      }]
    };
  
    let updateInfoNew: IElementUpdate = {
      action: "INSERT", //INSERT DELETE UPDATE
      field: brandAction.section.toUpperCase(),
      value: element
    }
    addUpdateBrand([updateInfoNew], undefined, !brandDetail?.brand?.id ? uuid() : undefined, undefined, undefined, `Color saved.` );
  }

  const disabledButton = ()=> {
    return color=='' ? true  : saving;
  }
  
  return (
    <S.Root
      topValue={props.position?.top}
      rightValue={props.position?.right}
    >
      <ClickOutside onClickOutside={()=> setBrandAction(undefined)} event={"mousedown"}>
        <S.Row drawBox={true}>
          <section className="colorgen">
            <ColorGenerator 
            show={true} 
            color={initialColor} 
            showInputText={true} 
            onChange={handleColorGeneratorChange}/>
          </section>
          <S.ColorGeneratorButton disabled={disabledButton()} onClick={()=>color!='' && addColor()}>
              <S.ColorGeneratorButtonText disabled={disabledButton()}>
                  {saving ? `SAVING..` : `ADD`}
              </S.ColorGeneratorButtonText>
          </S.ColorGeneratorButton>
        </S.Row>
      </ClickOutside>
    </S.Root>
  );

}

export default AddColor;